import { toggleIsLoading } from './loading'
import messageActions from './message'
import surveyConstants from '../constants/survey';
import surveyService from '../services/survey';
import promotionService from '../services/promotion';
import modalActions from './modal';

const surveyCreate = (detail) => ({ type: surveyConstants.CREATE_SURVEY, detail })
const surveyList = (data) => ({ type: surveyConstants.LIST_SURVEY, data })
const surveyRetrieve = (detail) => ({ type: surveyConstants.RETRIEVE_SURVEY, detail })
const surveyUpdate = (detail) => ({ type: surveyConstants.UPDATE_SURVEY, detail })
const surveyDestroy = () => ({ type: surveyConstants.DESTROY_SURVEY })
const surveyClear = () => ({ type: surveyConstants.CLEAR_SURVEY });

const surveyActions = {}

surveyActions.clearSurvey = () => {
  return (dispatch) => {
    dispatch(surveyClear())
  }
}

surveyActions.list = (vendorApiKey, locationApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    surveyService.list(vendorApiKey, locationApiKey)
    .then((response) => {
      dispatch(surveyList(response));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

surveyActions.retrieve = (vendorApiKey, locationApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    surveyService.list(vendorApiKey, locationApiKey)
    .then((response) => {
      dispatch(surveyRetrieve(response));
      dispatch(toggleIsLoading(false));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

const createWithPromotion = (body, promotionBody, vendorApiKey, locationApiKey, dispatch) => {
  dispatch(toggleIsLoading(true));
  promotionService.create(promotionBody, vendorApiKey, locationApiKey)
  .then((res) => {
    body['promotion_apikey'] = res.apikey;
    createWithoutPromotion(body, vendorApiKey, locationApiKey, dispatch);
  })
  .catch((error) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(error.message));
  })
}

const createWithoutPromotion = (body, vendorApiKey, locationApiKey, dispatch) => {
  dispatch(toggleIsLoading(true));
  surveyService.create(body, vendorApiKey, locationApiKey)
  .then((response) => {
    dispatch(surveyCreate(response));
    dispatch(toggleIsLoading(false));
    dispatch(surveyActions.list(vendorApiKey, locationApiKey));
    dispatch(modalActions.modalToggle(false));
  })
  .catch((err) => {
    dispatch(toggleIsLoading(false));
    dispatch(messageActions.setErrorMessage(err.message));
  })
}

surveyActions.create = (body, promotionBody, vendorApiKey, locationApiKey) => {
  return (dispatch) => {
    if (promotionBody)
      createWithPromotion(body, promotionBody, vendorApiKey, locationApiKey, dispatch);
    else
      createWithoutPromotion(body, vendorApiKey, locationApiKey, dispatch);
  }
}

const updateWithPromotion = (body, promotionBody, vendorApiKey, locationApiKey, surveyApiKey, promotionApiKey, dispatch) => {
  dispatch(toggleIsLoading(true));
  promotionService.update(promotionBody, vendorApiKey, locationApiKey, promotionApiKey)
  .then((res) => {
    body['promotion_apikey'] = res.apikey;
    updateWithoutPromotion(body, vendorApiKey, locationApiKey, surveyApiKey, dispatch);
  })
  .catch((error) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(error.message));
  })
}

const updateWithoutPromotion = (body, vendorApiKey, locationApiKey, surveyApiKey, dispatch) => {
  dispatch(toggleIsLoading(true));
  surveyService.update(body, vendorApiKey, locationApiKey, surveyApiKey)
  .then((response) => {
    dispatch(surveyUpdate(response));
    dispatch(toggleIsLoading(false));
    dispatch(surveyActions.list(vendorApiKey, locationApiKey));
    dispatch(modalActions.modalToggle(false));
  })
  .catch((err) => {
    dispatch(toggleIsLoading(false));
    dispatch(messageActions.setErrorMessage(err.message));
  })
}

surveyActions.update = (body, promotionBody, vendorApiKey, locationApiKey, surveyApiKey, promotionApiKey=false) => {
  return (dispatch) => {
    if (promotionApiKey)
      updateWithPromotion(body, promotionBody, vendorApiKey, locationApiKey, surveyApiKey, promotionApiKey, dispatch);
    else
      updateWithoutPromotion(body, vendorApiKey, locationApiKey, surveyApiKey, dispatch);
  }
}

surveyActions.destroy = (body, vendorApiKey, locationApiKey, surveyApiKey) => {
  return (dispatch) => {
    dispatch(toggleIsLoading(true));
    surveyService.destroy(body, vendorApiKey, locationApiKey, surveyApiKey)
    .then((response) => {
      dispatch(surveyDestroy());
      dispatch(toggleIsLoading(false));
      dispatch(surveyActions.list(vendorApiKey, locationApiKey));
    })
    .catch((err) => {
      dispatch(toggleIsLoading(false));
      dispatch(messageActions.setErrorMessage(err.message));
    })
  }
}

export default surveyActions;



/** WEBPACK FOOTER **
 ** ./src/actions/survey.js
 **/